module.exports = __webpack_public_path__ + "img/cadastro-usuarios-oficina.cc96fad9.jpg";